import { render, staticRenderFns } from "./housePeizhi.vue?vue&type=template&id=69e2cab9&scoped=true&"
import script from "./housePeizhi.vue?vue&type=script&lang=js&"
export * from "./housePeizhi.vue?vue&type=script&lang=js&"
import style0 from "./housePeizhi.vue?vue&type=style&index=0&id=69e2cab9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e2cab9",
  null
  
)

export default component.exports